import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { AppThunk } from "./app"
import API_URL from "../config/ApiUrl"
import api from "./api"

interface SupportProvider {
    status: []
}
const initialState = {
    status: []
} as SupportProvider

const SupportProviderSlice = createSlice({
    name: "SupportProvider",
    initialState,
    reducers: {
        setStatus: (state, action: PayloadAction<any>) => {
            state.status = action.payload
        }
    }
})

export const { setStatus } = SupportProviderSlice.actions

export const fetchListSupportProvider = (payload?: any): AppThunk<any> => async () => {
    try {
        const resp = await api.post(API_URL.SUPPORT_PROVIDER.LIST, payload);
        return Promise.resolve(resp.data.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}

export const addSupportProvider = (payload?: any): AppThunk<any> => async (dispatch) => {
    try {
        const res = await api.post(API_URL.SUPPORT_PROVIDER.ADD, payload);
        return Promise.resolve(res.data.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}

export const editSupportProvider = (payload?: any): AppThunk<any> => async (dispatch) => {
    try {
        const res = await api.post(API_URL.SUPPORT_PROVIDER.EDIT, payload);
        return Promise.resolve(res.data.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}

export const deleteSupportProvider = (payload?: any): AppThunk<any> => async (dispatch) => {
    try {
        const res = await api.post(API_URL.SUPPORT_PROVIDER.DELETE, payload);
        return Promise.resolve(res.data.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}

export default SupportProviderSlice.reducer